<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Member Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Member Details",
            items: [
               {
                  text: "Members",
                  href: "/patients",
               },                
               {
                  text: "Members",
                  href: "/patients/members",
               }, 
               {
                  text: "Details",
                  active: true,
               },                     
            ],
            member:{},
            patient:{},
            bookings:"",
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchMember();
      },
      methods: {
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },   
         
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         fetchMember(page_url = null) {

         this.getToken();
         let url = "clinic/member_profile?id=" + this.$route.params.id;

         page_url = page_url || url;

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;
         this.loading = true;

         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.member = responseData.member;
               this.patient = responseData.patient;
               this.bookings = responseData.bookings;

         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
         })
         .finally(() => (this.loading = false));
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <!-- <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
                        <router-link :to="{ name: 'patients.members', params: {id: patient.id} }" class="btn btn-primary float-end">Back</router-link>

                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">
                        <b-card header-class="bg-transparent border-light" class="border border-light">

                        <div class="card overflow-hidden">
                          
                              <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">User Details</h4>

                           <!-- </div> -->
                           <div class="card-body pt-2">
                              <div class="row">
                                 
                                 <div class="col-sm-12 align-self-center">
                                   
                                    <p class="font-size-14 mt-3 mb-1">
                                       
                                       {{patient.patient_name}}
                                    </p>
                                    <p class="font-size-14 mt-3 mb-1">
                                       <i class="bx bx-phone me-1 text-primary"></i> 
                                       {{patient.country_code}} {{patient.mobile}}
                                    </p>
                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-envelope me-1 text-primary"></i>
                                       {{patient.email}}
                                    </p>

                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-map me-1 text-primary"></i>
                                       {{patient.address}}
                                    </p>
                                 </div>
                              </div>                              

                           </div>
                        </div>
                     </b-card>
                        <!-- <div class="d-grid gap-2">
                           <b-button v-b-modal.password-modal block variant="primary">Change Password</b-button>
                           
                           <router-link :to="{ name: 'customers.edit' }" class="btn btn-primary">Edit Profile</router-link>  
                        </div> -->



                        <!-- <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-certificate font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Tokens</p>
                                 <h4 class="mb-0">3 <b-button v-b-modal.token-modal variant="outline-primary" class="btn-sm float-end">Add Token</b-button></h4>
                                 
                              </div>                              
                           </div>
                        </b-card> -->
                     </div>

                     <div class="col-lg-7 col-md-7">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">Member Details</h4>
                              

                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>
                                       <tr width="50%">
                                          <th scope="row">Name</th>
                                          <th>:</th>
                                          <td>{{member.name}}</td>
                                       </tr>
                                       <tr width="50%">
                                          <th scope="row">Gender</th>
                                          <th>:</th>
                                          <td>
                                             <span v-if="member.gender==1">Male</span>
                                             <span v-else-if="member.gender==2">Feale</span>
                                             <span v-else>Others</span>
                                          </td>
                                       </tr> 

                                       <tr>
                                          <th scope="row">D.O.B</th>
                                          <th>:</th>
                                          <td>{{member.dob| formatDate}}</td>
                                       </tr>  

                                         <tr>
                                          <th scope="row">Age</th>
                                          <th>:</th>
                                          <td>{{member.age}}</td>
                                       </tr>  

                                       <tr>
                                          <th scope="row">Relation</th>
                                          <th>:</th>
                                          <td>{{member.relationship}}</td>
                                       </tr> 

                                       <tr>
                                          <th scope="row">Created On</th>
                                          <th>:</th>
                                          <td>{{member.converted_created_at}}</td>
                                       </tr>    
                                         
                                    </tbody>
                                 </table>
                              </div>
                           
                        </b-card>
                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-stethoscope font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Bookings</p>
                                 <h4 class="mb-0">{{bookings}}</h4>
                              </div>                              
                           </div>
                        </b-card>
                        <!-- end card -->

                        <!-- <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Prescriptions</h4>
                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3">                                 
                                 <a href="#"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Prescription 1</p></a>  
                              </li>

                              <li class="mb-3">                                 
                                 <a href="#"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Prescription 2</p></a>  
                              </li>
                              
                           </ul>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Medical Reports</h4>
                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3">
                                 <a href="#"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Medical Report 1</p></a>  
                              </li>


                              <li class="mb-3">
                                 <a href="#"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Medical Report 2</p></a>  
                              </li>
                           </ul>
                        </b-card> -->

                     </div>
                     
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="changePassword()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">New Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password"></b-form-input>

                  
               </b-col>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password_confirmation"></b-form-input>

                  
               </b-col>    
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->

      <!---- modal starts ---->
      <b-modal ref="token-modal" id="token-modal" title="Add Token" hide-footer>
         <b-form>
            <b-row>                          

               <b-col md="12" class="form-group">
                  <label class="control-label">Count<span class="required">*</span></label>
                  <b-form-input></b-form-input>
                  
               </b-col>                           
                           
               <b-col md="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('token-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
